import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import LeadScoreSummaryWrapper from "../LeadScoreSummaryWrapper/LeadScoreSummaryWrapper";

const LeadScoreSummaryLoading = () => (
    <Flex
        gap="16px"
        flexDirection="column"
    >
        <Flex
            gap="5px"
            flexDirection="column"
        >
            <PixelPlaceholderLoader
                width="100%"
                height={20}
            />
            <PixelPlaceholderLoader
                width="50%"
                height={20}
            />
        </Flex>

        <LeadScoreSummaryWrapper>
            <Flex
                gap="5px"
                flexDirection="column"
                width="100%"
            >
                <PixelPlaceholderLoader
                    width="100%"
                    height={20}
                />
                <PixelPlaceholderLoader
                    width="75%"
                    height={20}
                />
            </Flex>
        </LeadScoreSummaryWrapper>
    </Flex>
);

export default LeadScoreSummaryLoading;
